export const serviceID = 'service_yyoh07s';
export const templateID = 'template_7easn6r';
export const publicKey = 'Y0FsCKP2sl3QuvTcf';